module.exports = __webpack_public_path__ + "img/m-banner-csrrksao-es-ES.e8eaf239.jpg";